import React from 'react';
// import { useHistory } from 'react-router-dom';
import Table from '../components/Table/Table';
import usePpsis from '../features/PpsiContainer/hooks/usePpsis';
// import { ppsiInProgressRoute } from '../routes';
import { EnrichmentData, States } from '../features/PpsiContainer/constants';
import useViewVisited from '../features/app/hooks/useViewVisted';
import ppsiColumns from '../features/PpsiContainer/ui/columns';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';

const Columns = ppsiColumns(EnrichmentData.IN_PROGRESS);

const PpsiApprovedListView = () => {
  // const history = useHistory();
  const [isFetching, ppsisRaw] = usePpsis({ status: States.SCHEDULED });
  const { isViewVisited } = useViewVisited(
    View.PpsiListApproved.name,
    isFetching
  );
  const isFetched = isViewVisited ? true : !isFetching;
  const ppsis = toJS(ppsisRaw, []);

  // const viewApprovedPpsi = ppsi => {
  //   history.push(ppsiInProgressRoute(ppsi.id));
  // };

  View.PpsiListApproved.visit();

  return (
    <PaperContainer showProgress={!isFetched}>
      <Table
        title="ppsi.approvedListTableTitle"
        data={ppsis}
        columns={[
          Columns.IfoodID,
          Columns.PresentationName,
          // Columns.RangeCategory,
          Columns.ActualApprovalDate,
          Columns.ApprovedBy,
          Columns.TargetPublishDate,
          Columns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        // onRowClick={viewApprovedPpsi}
      />
    </PaperContainer>
  );
};

export default PpsiApprovedListView;
